import React, { useEffect, useState, memo } from 'react'
import Paper from '@mui/material/Paper'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import SearchIcon from '@mui/icons-material/Search'
import sx from './styles'

const SearchBar = ({ onClick, search }) => {
  const [textInput, setTextInput] = useState('')
  const onChangeText = (e) => {
    setTextInput(e.target.value)
  }
  const onSearch = (e) => {
    e.preventDefault()
    onClick(textInput)
  }
  useEffect(() => {
    setTextInput(search)
  }, [search])

  return (
    <Paper
      component="form"
      sx={sx.mainContainer}
    >
      <TextField
        sx={sx.inputSearch}
        placeholder="Busca dentro de nuestro blog"
        onChange={onChangeText}
        value={textInput}
        InputProps={{
          endAdornment: (
            <IconButton
              type="submit"
              aria-label="search"
              onClick={onSearch}
            >
              <SearchIcon sx={sx.searchIcon} />
            </IconButton>
          ),
        }}
      />
    </Paper>
  )
}

export default memo(SearchBar)
